import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../../src/appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from "../../src/core/rest";
import _ from "lodash";
import { formatLocalDateForDispaly } from "../core/DateTimeHelper";

export const GetEventLogs = createAsyncThunk(
    "EventLogs/GetEventLogs",
    async (request) => {
        try {
            let event_types = '';
            if (request.event_types.length > 0) {
                event_types = request.event_types.join(',');
            }
            let start = '';
            let end = '';

            if (request.startDate !== null && request.startDate !== "") {
                start = new Date(request.startDate).toUTCString();
            }

            if (request.endDate !== null && request.endDate !== "") {
                end = new Date(request.endDate).toUTCString();
            }

            const response = await Rest.get(
                ApiGatewayUrl + "/eventlogs?page_no=" + request.page_no + "&rows_per_page=" + request.rows_per_page + "&search=" + request.camera + "&event_types=" + event_types + "&startDate=" + start + "&endDate=" + end
            );
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);
export const ExportCSV = createAsyncThunk(
    "EventLogs/ExportCSV",
    async (request) => {
        try {
            let event_types = '';
            if (request.event_types.length > 0) {
                event_types = request.event_types.join(',');
            }
            let start = '';
            let end = '';

            if (request.startDate !== null && request.startDate !== "") {
                start = new Date(request.startDate).toUTCString();
            }

            if (request.endDate !== null && request.endDate !== "") {
                end = new Date(request.endDate).toUTCString();
            }
            const response = await Rest.get(
                ApiGatewayUrl + "/eventlogs/exportCSV?camera=" + request.camera + "&event_types=" + event_types + "&startDate=" + start + "&endDate=" + end + "&timeZone="+ Intl.DateTimeFormat().resolvedOptions().timeZone
            );
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);
export const eventLogSlice = createSlice({
    name: "eventLog",
    initialState: {
        eventLogs: [],
        isLoading: false,
        total: 0,
        eventTypesList: [],
        eventLogCSVs: [],
        downloadUrl: "",
    },
    reducers: {
        clearDownloadUrl: (state) => {
            state.downloadUrl = '';
        },
        updateDownloadUrl: (state, action) => {
            state.downloadUrl = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetEventLogs.pending, (state) => {
                return {
                    ...state,
                    isLoading: true
                }
            })
            .addCase(GetEventLogs.fulfilled, (state, action) => {
                const logs = _.map(action.payload.eventLogs.queryResults, (l) => {

                    return {
                        id: l.id,
                        timeStamp: formatLocalDateForDispaly(l.userActivity.timeStamp),
                        eventTypeDesc: l.userActivity.eventTypeDesc,
                        eventType: l.userActivity.eventType,
                        user: l.userActivity.user,
                        camera: l.userActivity.camera,
                        details: l.userActivity.details
                    }
                })

                return {
                    ...state,
                    eventLogs: logs.sort(compare),
                    total: action.payload.eventLogs.total,
                    eventTypesList: action.payload.eventTypeList,
                    isLoading: false
                }
            })
           
    }
}

);
export const eventLogActions = eventLogSlice.actions;
export const eventLogState = (state) => state.eventLog;
export default eventLogSlice.reducer;
const compare = (a, b) => {
    if (a.timeStamp > b.timeStamp) {
        return -1;
    }
    if (a.timeStamp < b.timeStamp) {
        return 1;
    }
    return 0;
};
